import "../styles/auth.css";

function Placeholder() {
  // Placeholder UI lets product/design iterate before API integration.
  return (
    <section className="feature-shell">
      <h2>Auth Feature</h2>
      <p>Use this space to sketch login, registration, and session flows.</p>
    </section>
  );
}

export default Placeholder;
